import React, {useRef, useState} from 'react';
import {
    StackLayout
} from '@salt-ds/core';

import '../CommonCard.css';
import ChangePasswordComponent from "../../components/common/ChangePasswordComponent";
import PageNavigationCustom from "../../components/common/page-navigation/PageNavigationCustom";


function FirstTimeLogInSetupForm(props) {
  const formRef = useRef();

  const handlebuttonClick = () => {
      props.setIsLoading(true);
      if(formRef.current) {
          formRef.current.submitForm();
      }
  }
  return (
      <StackLayout>
        <ChangePasswordComponent
          ref={formRef}
          showErrorOnPage={props.showErrorOnPage}
          redirectUrl={"/firstTimeLogInSetupRegisterComputer"}
          isFirstTimeUserFlow={true}
          setIsLoading={props.setIsLoading}
          isLoading={props.isLoading}
        />
        <PageNavigationCustom onSubmit={handlebuttonClick} backButton={true} isLoading={props.isLoading}/>
      </StackLayout>
  );
}


export default FirstTimeLogInSetupForm;